<template>
  <div class="rules-container">
    <Modal
      title
      @on-cancel="close"
      v-model="wechatPop"
      width="530"
      class-name="vertical-center-modal wechat-modal"
    >
      <div>
        <div class="qrcode-title">
          <p>{{title}}</p>
        </div>
        <div class="qrcode-title-en">
          <p>{{tilte_en}}</p>
        </div>

        <img class="qrcode" src="https://static.getconnectplus.com/tb_webassets/tb_oa_qrcode.jpeg?x-oss-process=style/tb_footer_qrcode_w_300" />
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "wechatPop",
  data() {
    return {
      title: "扫描二维码关注微信公众号",
      tilte_en: "SCAN TO FOLLOW OFFICIAL WECHAT ACCOUNT",
      visitStatus: false
    };
  },
  props: {
    wechatPop: {
      type: Boolean,
      default: false
    }
  },
  created() {
    var isWeiXin = this.getisWeiXin();
    var isMobile = this.getisMobile();
    if (isMobile && !isWeiXin) {
      this.title = "截屏并扫描二维码关注微信公众号";
      this.tilte_en =
        "TAKE A SCREENSHOT AND SCAN TO FOLLOW WECHAT OFFICIAL ACCOUNT";
    }
  },
  mounted() {},
  components: {},
  methods: {
    getisMobile() {
      if (
        navigator.userAgent.match(
          /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    getisWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf("micromessenger") > -1) {
        return true; // 是微信端
      } else {
        return false;
      }
    },
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="less" scoped>
.part-container {
  padding-top: 3rem;
}
/deep/.wechat-modal .ivu-modal-content {
  // min-width: 58.2rem;
  max-width: 100vw;
  min-height: 51rem;
  max-height: 100vh;
  padding: 5.2rem;
  background-color: #fff;
  margin: auto;
  display: flex;
  justify-content: space-around;
  text-align: center;
  align-items: center;
  background-color: #fff;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border: 0.1rem solid #959595;
}
/deep/.wechat-modal .ivu-modal-body {
  padding: 0;
  line-height: 1.2;
  .qrcode-title {
    margin: 0 0 2.5rem;
    font-size: 1.8rem;
  }
  .qrcode-title-en {
    margin: 0 0 5rem;
    color: #969696;
    font-size: 1.8rem;
  }
  img {
    max-width: 21.5rem;
  }
}
/deep/.ivu-modal-mask {
  background-color: rgba(55, 55, 55, 0);
}
/deep/.ivu-modal-close {
  display: initial;
}
/deep/.wechat-modal {
  //   position: fixed;
  // top: 0;
  // right: 0;
  // bottom: 0;
  // left: 0;
  // z-index: 100;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // font-size: 1.2rem;
  background-color: rgba(0, 0, 0, 0.5);
}
@media screen and (max-width: 1024px) {
  /deep/.wechat-modal .ivu-modal-content {
    width: calc(100% - 4rem);
    min-height: 15rem;
  }
}
@media screen and (max-width: 768px) {
  .wechat-modal .ivu-modal-body .qrcode-title-en {
    margin-bottom: 2.5rem;
  }
  .wechat-modal .ivu-modal-body .qrcode-title-en p {
    font-size: 1.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/WeChatPop.vue